<template>
  <a-modal visible :title="title" @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import store from '@/store'
export default {
  data () {
    return {
      data: {
        Client: '',
        finishProduct: '',
        clientCommission: null
      },
      options: [
        {
          name: 'Client',
          note: '客户',
          type: 'Pointer',
          targetClass: 'Client',
          listWhere: (where) => {
            if (store.state.user && store.state.user.allClient === 'No') {
              where.userid = store.state.user.objectId
            }
          },
          validators: [
            (val) => val ? null : '型号名称不可为空'
          ]
        },
        {
          name: 'finishProduct',
          note: '成品型号',
          type: 'Pointer',
          targetClass: 'finishProduct',
          listWhere: (where) => {
            where.isBatching = false
            if (store.state.user && store.state.user.allShopManagements === 'No') {
              where.workShop = { $in: store.state.user.shopManagements }
            }
          },
          validators: [
            (val) => val ? null : '成品型号不可为空'
          ]
        },
        {
          name: 'clientCommission',
          note: '客户提成',
          type: 'Number',
          validators: [
            (val) => val ? null : '客户提成不可为空'
          ]
        }
      ]
    }
  },

  methods: {
    async submit () {
      // 验证必填项
      let error = await this.$refs.input.validate()
      if (Object.keys(error).length === 0) {
        let res = await this.$modelAjax.getData('clientCommission', {
          params: {
            where: {
              Client: this.data.Client,
              finishProduct: this.data.finishProduct
            }
          }
        })
        if (res.results.length) {
          throw this.$notification['error']({
            message: '保存失败',
            description: '存在相同的客户与成品型号'
          })
        } else {
          await this.$modelAjax.post('clientCommission', this.data).catch(e => {
            throw this.$notification['error']({
              message: '保存失败',
              description: '保存失败，请重新尝试'
            })
          })
          this.vm.refresh()
          this.$emit('complete', 'cancel')
        }
      }
    },
    cancel () {
      this.$emit('complete')
    }
  },
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String, // 假如当前model显示为category格式，则会将当前的值传入
    title: String
  }
}
</script>

<style>

</style>
